<template>
  <div id="order-view">
    <div v-if="order_not_found">
      <b-alert show variant="danger">
        <h5 class="alert-heading"><i class="mdi mdi-block-helper mr-2"></i>Order Not Found!</h5>
        <hr class="my-1">
        <p class="mb-0">
          <span class="mr-2">Order record with id: {{ $route.params.orderId }} not found. </span><router-link to="/orders" class="btn btn-danger btn-sm">Return to Orders</router-link>
        </p>
      </b-alert>
    </div>
    <div v-if="!isLoading">
      <div class="row">
        <div class="col-12 no-top-padding">
            <b-tabs nav-class="nav-tabs nav-bordered">
                <b-tab title="Overview" :active="activeTab === 0">
                  <order-overview />
                </b-tab>
                <b-tab title="Messages" :active="activeTab === 1" :lazy="activeTab != 1">
                  <order-messages />
                </b-tab>
            </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderOverview from "./OrderOverview.vue"
import OrderMessages from "./OrderMessages.vue"

export default {
  components: {
    OrderOverview,
    OrderMessages,
  },
  data() {
    return {
      isLoading: true,
      order_not_found: false,
    }
  },
  watch: {
    "$route":"fetchOrder"
  },
  computed: {
    order(){
      return this.$store.state.orderList.order
    },
    activeTab(){
      return this.$route.query.tab ? +this.$route.query.tab : 0;
    },
  },
  methods:{
    fetchOrder(){
      this.isLoading = true
      this.$store.dispatch("changeLoaderValue",true)
      this.$store.dispatch("orderList/fetchOrder",this.$route.params.orderId)
      .then((response) => {
        this.$store.dispatch("changeLoaderValue",false)
         if(response.data.success){
            this.isLoading = false
            this.updateBreadcrumb()
          }else{
            this.order_not_found = true
            this.alertError(response.data.error)
          }
      }).catch((error) => { console.log(error); this.order_not_found = true })
    },
    updateBreadcrumb(){
        let breadcrumb = [
            {
                text: `${this.order.status.charAt(0).toUpperCase() + this.order.status.slice(1) } Orders`,
                to: { path: `/orders/?status=${this.order.status}` }
            },
            {
                text: "Show",
                active: true
            }
        ]
        this.$route.meta.breadcrumb = [...breadcrumb]
    },
  },
  created(){
    this.fetchOrder();
  },
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
.no-top-padding .tab-content{
    padding-top:1px !important;
}
</style>
